import { io } from 'socket.io-client';
import { NotificationManager } from 'react-notifications';
import { createCookie, readCookie, eraseCookie } from './cookies';
import events from '../events';
import { locales } from '../translations/locales';
import { _$, _hide } from './dom';
import socketManage from './socketManage';

export const socket = io('https://alpha.modrp.alertes-speciales.fr', { path: '/socket.io' }, { transports: ['websocket'] });
export const socketSite = io('https://alertes-speciales.fr', { path: '/site/socket.io' }, { transports: ['websocket'] });

socketManage(socket);
socketManage(socketSite);
/**
 * User session
 * @override
 */
class Session {
    /**
     * Init the Session constructor
     */
    constructor() {
        this.isValide = false;
        this.nbUpdate = 0;
        setTimeout(() => { // TODO todo Todo Vérifier si un timeout est une bonne idée sans vérification en plus pour tester si socket existe
            this.sessionId = socket.id;
            this.socketSite = socketSite;
            this.socket = socket;
        }, 100);
        this.userName = false;
        this.key = false;
        this.setUpdate = null;
        this.setMenuOpen = null;
        this.locale = readCookie('lang');
    }

    changeLocale = (locale) => {
        this.locale = locale;
    };

    init = (setUpdate, setMenuOpen) => {
        this.setUpdate = setUpdate;
        this.setMenuOpen = setMenuOpen;
        if (readCookie('test') && readCookie('test') === 'true') {
            _hide('confirm-cookies');
            if (readCookie('_asid')) {
                setTimeout(() => this.socketSite.emit(events.TEST_SESSION, readCookie('_asid')), 100);
            }
        } else {
            NotificationManager.error(locales[this.locale].notifications.cookiesError, locales[this.locale].title, 5000);
        }
    };

    update = () => {
        this.nbUpdate++;
        this.setUpdate(new Date());
    };

    validUser = (userName, key) => {
        if (this.isValide) return;
        this.isValide = true;
        this.userName = userName;
        this.key = key;
        this.update();
    };

    invalidUser = () => {
        eraseCookie('_asid'); eraseCookie('_asrem');
        this.isValide = false;
        this.userName = false;
        this.key = false;
        this.update();
        this.setMenuOpen(false);
        NotificationManager.error(locales[this.locale].notifications.invalidSession, locales[this.locale].notifications.register, 3000);
    };

    disconnect = () => {
        eraseCookie('_asid'); eraseCookie('_asrem');
        NotificationManager.success(locales[this.locale].notifications.logOutSuccess, locales[this.locale].notifications.logOut, 3000);
        this.isValide = false;
        this.userName = false;
        this.key = false;
        this.update();
        this.setMenuOpen(false);
    };

    connexion = () => {
        const userName = _$('pseudo').value;
        const pwd = _$('password').value;
        const persist = _$('persist').checked;
        this.socketSite.emit(events.CONNEXION, userName, pwd, persist);
    };

    validConnexion = (userName, key, persist) => {
        _$('modalClose').click();
        if (persist) {
            createCookie('_asid', `${userName},${key}`, 7);
            createCookie('_asrem', true, 7);
        } else {
            createCookie('_asid', `${userName},${key}`);
            createCookie('_asrem', false);
        }
        this.isValide = true;
        this.userName = userName;
        this.key = key;
        this.update();
        NotificationManager.success(`${locales[this.locale].notifications.welcome} ${this.userName}`,
            locales[this.locale].notifications.logInSuccess, 3000);
    };

    forgotPwd = () => {
        const userName = _$('username').value;
        this.socketSite.emit(events.FORGOT_PWD, userName);
    };

    inscription = () => {
        const user = _$('nomCompte').value;
        const mail = _$('email').value;
        const psw = _$('password').value;
        const pswC = _$('password-confirm').value;
        const parrain = _$('code-parrainage').value;
        const reg = /^[a-zA-Z-0-9]+$/;
        if (!reg.test(user) || user.length > 19 || user.length < 5) {
            return NotificationManager.error(locales[this.locale].notifications.signInError1, locales[this.locale].notifications.signIn, 3000);
        }
        if ((mail.indexOf('@') >= 0) && (mail.indexOf('.') >= 0)) {

        } else {
            return NotificationManager.error(locales[this.locale].notifications.signInError2, locales[this.locale].notifications.signIn, 3000);
        }
        if (psw === pswC && user !== '' && psw.length >= 6 && psw.length < 50 && psw !== user) {
            this.socketSite.emit(events.INSCRIPTION, user, psw, mail, parrain);
        } else {
            return NotificationManager.error(locales[this.locale].notifications.signInError3, locales[this.locale].notifications.signIn, 3000);
        }
    };

    acceptCookies = () => {
        _hide('confirm-cookies');
        createCookie('test', 'true', 400);
    };
};

export const session = new Session();
